module.exports = __webpack_public_path__ + "img/contact.3db2526b.png";